import { render } from "./btcMyInscriptions.vue?vue&type=template&id=f09d733a"
import script from "./btcMyInscriptions.vue?vue&type=script&lang=js"
export * from "./btcMyInscriptions.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__